module.exports = __webpack_public_path__ + "static/media/submission-hero.782b776c.jpg";